exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".addEditFixedSetDialog-paper {\n  overflow-y: initial !important; }\n\n.add-fixed-set-content {\n  overflow: initial;\n  overflow-y: initial !important;\n  max-width: 500px;\n  padding-bottom: 0 !important; }\n  .add-fixed-set-content .select-search {\n    margin-bottom: 7px; }\n    .add-fixed-set-content .select-search .react-select-text-field + div > div {\n      max-height: 200px; }\n  .add-fixed-set-content .set-image {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n    justify-content: center; }\n\n@media only screen and (min-width: 768px) {\n  .add-fixed-set-content {\n    min-width: 300px; } }\n\n/*\n@media only screen and (max-width: 767px) {\n    .add-fixed-set-content {\n        overflow-x: hidden;\n    }\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/dynamicSets/AddEdit/AddEditDynamicSet.scss
// module id = 1672
// module chunks = 0